
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { ImagePlus, Trash2 } from 'lucide-react';
import React from 'react';

interface MediaSettingsProps {
  media: {
    logo?: string;
    background?: string;
  };
  onMediaChange: (mediaType: 'logo' | 'background', value: string | undefined) => void;
}

export function MediaSettings({ media, onMediaChange }: MediaSettingsProps) {

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, mediaType: 'logo' | 'background') => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onMediaChange(mediaType, reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const renderImageUploader = (type: 'logo' | 'background', label: string) => {
    const currentImage = media?.[type];
    
    return (
      <div className="space-y-2">
        <Label htmlFor={`${type}-upload`}>{label}</Label>
        {currentImage && (
          <div className="relative group w-full aspect-video rounded-md overflow-hidden border">
            <img src={currentImage} alt={`${label} preview`} className="w-full h-full object-contain bg-gray-100" />
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <Button
                variant="destructive"
                size="icon"
                onClick={() => onMediaChange(type, undefined)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
        )}
        <div className="relative">
          <Input
            id={`${type}-upload`}
            type="file"
            accept="image/png, image/jpeg, image/svg+xml"
            className="w-full h-full absolute inset-0 opacity-0 cursor-pointer"
            onChange={(e) => handleFileChange(e, type)}
          />
          <div className="border-2 border-dashed border-gray-300 rounded-md p-4 text-center cursor-pointer hover:bg-gray-50 transition-colors">
            <ImagePlus className="mx-auto h-8 w-8 text-gray-400" />
            <p className="mt-2 text-sm text-gray-600">
                {currentImage ? 'تغيير الصورة' : 'انقر أو اسحب صورة إلى هنا'}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {renderImageUploader('logo', 'شعار الشركة')}
      {renderImageUploader('background', 'صورة الخلفية')}
    </div>
  );
}
